import { useGetPrintQueueEntriesQuery } from '../../../../store/api/print-queue-entries-api'
import { Zones } from '../../../../types/api/print-queue-entry'
import { EndpointQueryParameters } from '../../../../types/strapi/strapi'
import {
    materialRequirementsPopulate,
    shipmentAvailabilityPopulate,
} from '../constants/shipment-populate'

const queryParams: EndpointQueryParameters = {
    filters: {
        zone: { $eq: Zones.Main },
    },
    populate: {
        print_job: {
            populate: {
                shipment: {
                    populate: {
                        ...shipmentAvailabilityPopulate,
                        client: true,
                        shipment_positions: true,
                        materialRequirements: { populate: materialRequirementsPopulate },
                        machine: true,
                        additional_machines: true,
                        calculated: true,
                        calculatedOnActual: true,
                    },
                },
                print_queue_entries: {
                    populate: {
                        machine: true,
                    },
                },
                print_job_executors: {
                    populate: {
                        machine: true,
                    },
                },
            },
        },
        machine: {
            populate: {
                machine_brand: true,
            },
        },
    },
    sort: ['sort:desc'],
    pagination: { pageSize: 1000, page: 1 },
}

export default function usePrintPlanSummaryEntries() {
    const { data, ...rest } = useGetPrintQueueEntriesQuery(queryParams)

    return {
        ...rest,
        entries: data?.data || [],
    }
}
